module.exports = __webpack_public_path__ + "e4ef02c22d7c22417eb45ca9dae226e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/img/emptylogo.jpg
// module id = 583
// module chunks = 0